
import { Component, Vue } from "vue-property-decorator";
import { API_ROUTES } from "@/utils/API";
import { TGuide } from "@/models/guide";

const VALUE_TITLE = "guide_alias";
const VALUE_ROLE = "role";

@Component({
  components: {
    GuideCard: () => import("./components/GuideCard.vue"),
    Loader: () => import("@/components/Loader/Loader.vue"),
  },
})
export default class Browse extends Vue {
  guides: TGuide[] = [] as TGuide[];

  loading = false;

  mounted() {
    this.fetchCards();
  }

  async fetchCards() {
    try {
      this.loading = true;

      const { data } = await this.axios.get(API_ROUTES.GUIDES);

      this.guides = data;
    } finally {
      this.loading = false;
    }
  }

  headers = [
    {
      text: this.$t("table.headers.title"),
      value: VALUE_TITLE,
    },
    {
      text: this.$t("table.headers.availableFor"),
      value: VALUE_ROLE,
    },
  ];

  async openGuide({ ID }: { ID: number }) {
    await this.$router.push(`${this.$route.fullPath}/${ID}`);
  }
}
